<template>
  <div class="mb-3">
    <label class="text-muted small mb-1">{{ description }}</label>
    <div class="row align-items-center">
      <div class="col-6">
        <div class="input-group" v-if="isPercent">
          <input
            v-model="instalment.percent"
            type="number"
            @blur="save"
            class="form-control"
            :disabled="isDisabled"
          />
          <span class="input-group-text">%</span>
        </div>
        <div class="input-group" v-if="isDollar">
          <span class="input-group-text">$</span>
          <my-currency-input
            v-model="instalment.total_ex"
            class="form-control"
            :disabled="isDisabled"
            @blur="save"
          >
          </my-currency-input>
        </div>
      </div>
      <div class="col-4">
        <div class="input-group" v-show="instalment.order != 1 && !isLast">
          <input
            v-model="instalment.days"
            type="number"
            @blur="save"
            class="form-control"
            :disabled="isDisabled"
          />
          <span class="input-group-text">Days</span>
        </div>
        <p class="mb-0" v-show="instalment.order == 1">Acceptance</p>
        <p class="mb-0" v-show="instalment.order != 1 && isLast">Completion</p>
      </div>
      <div class="col-2 text-end" v-if="!isDisabled">
        <button class="btn text-danger" @click="confirmDelete">
          <i data-v-33294c2f="" class="fal fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { notify } from "utils";
import { filters } from "mixins";
import draggable from "vuedraggable";
import { SET_SAVE_STATUS } from "vx/mutations";
import AppConstants from "@/support/app-constants";
import { filter, findIndex, intersectionBy, cloneDeep } from "lodash";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  mixins: [filters],

  props: ["initialInstalment", "index", "isLast", "type"],

  components: {
    draggable,
  },

  data() {
    return {
      instalment: {},
    };
  },

  mounted() {
    this.instalment = cloneDeep(this.initialInstalment);
  },

  watch: {
    initialInstalment: {
      deep: true,
      handler() {
        this.instalment = cloneDeep(this.initialInstalment);
      },
    },
  },

  computed: {
    ...mapGetters("opportunity", ["isSigned"]),
    ...mapState('opportunity', { opportunity: 'single' }),

    isDisabled () {
      return this.isSigned || this.opportunity.approved_at != null
    },

    description () {
      return this.instalment.description || 'Instalment ' + (this.index + 1)
    },

    isPercent () {
      return this.type == 'Percent'
    },

    isDollar () {
      return this.type == 'Dollar'
    }
  },

  methods: {
    ...mapMutations("settings/app", [SET_SAVE_STATUS]),
    ...mapActions("instalment", {
      deleteSingle: "deleteSingle",
      updateSingle: "updateSingle",
      getInstalments: "getList",
    }),

    confirmDelete() {
      this.$swal({
        title: "Confirm Delete",
        html:
          "Are you sure you want to delete " +
          this.description +
          "?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then(
        () => {
          this.deleteSingle(this.instalment.id).then(() => {
            // The API renumbers the remaining instalment descriptions on
            // delete, so re-fetch the list to pick up the new names.
            this.getInstalments({ opportunity_id: this.instalment.opportunity_id });
          });
        },
        function () {}
      );
    },

    save() {
      return this.updateSingle({
        id: this.instalment.id,
        payload: this.instalment,
      });
    },
  },
};
</script>
